<div class="select-container">
  <app-searchable-select-form-control
    class="w-100"
    [formControl]="navigationSelectFormControl"
    [options]="processedItems"
    [disableVirtualization]="true"
    [hasInitialFocusDisabled]="true"
    (selectionChanged)="onSelectionChange($event)"
  ></app-searchable-select-form-control>
</div>
